import Vue from "vue";
// global component
import Popup from "@/components/widgets/Popup";
import RelatedInfoDataTable from "@/views/crud/modules/RelatedInfoDataTable";

Vue.component("Popup", Popup);
Vue.component("RelatedInfoDataTable", RelatedInfoDataTable);